import { CALL_API } from 'redux-api-middleware';
import { baseUrl } from '../config';
import { createRequestTypes } from './utils';
import { convertFundColumns } from '../service/funds.js';
import { buildComponentUrl } from '../service/oms';
import normalizeSymbol from '../service/normalizesymbol';

export const CRYPTOCURRENCY_FETCH = createRequestTypes('@@tickers/CRYPTOCURRENCY_FETCH');
export const TICKER_DATA_RECEIVED = '@@tickers/TICKER_DATA_RECEIVED';
export const TICKER_DATA_REQUEST = createRequestTypes('@@tickers/TICKER_DATA_REQUEST');
export const TICKER_TYPE_REQUEST = createRequestTypes('@@tickers/TICKER_TYPE_REQUEST');

export function tickerDataReceived(symbol, data) {
    return { type: TICKER_DATA_RECEIVED, symbol, data, ready: true };
}

export function requestTickerData(symbol, columns = []) {
    const nSymbol = normalizeSymbol(symbol);

    return {
        [CALL_API]: {
            endpoint: buildComponentUrl({ symbol, columns }),
            method: 'GET',
            types: [
                TICKER_DATA_REQUEST.REQUEST,
                {
                    type: TICKER_DATA_REQUEST.SUCCESS,
                    payload: (action, state, res) => {
                        const contentType = res.headers.get('Content-Type');
                        if (contentType && ~contentType.indexOf('json')) {
                            return res.json().then(
                                json => {
                                    if (json.rows[0].values.INSTRUMENT_TYPE === 'FUNDS') {
                                        return convertFundColumns(json.rows[0]);
                                    }

                                    return json.rows[0];
                                }
                            );
                        }
                        return null;
                    },
                },
                TICKER_DATA_REQUEST.FAILURE,
            ],
            bailout: ({ tickers }) => tickers[nSymbol] && tickers[nSymbol].error,
        },
    };
}

// @TODO make a better solution for the toUpperCase() garbage
export const fetchCryptocurrency = (symbol) => ({
    [CALL_API]: {
        endpoint: `${baseUrl}/cryptocurrencies`,
        method: 'GET',
        types: [
            { type: CRYPTOCURRENCY_FETCH.REQUEST },
            {
                type: CRYPTOCURRENCY_FETCH.SUCCESS,
                payload: (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');
                    if (contentType && ~contentType.indexOf('json')) {
                        return res.json().then(
                            json => {
                                const uppercaseSymbol = symbol.toUpperCase();
                                for (let i = 0; json.length > i; i++) {
                                    if (json[i].key.toUpperCase() === uppercaseSymbol) {
                                        return {
                                            key: normalizeSymbol(json[i].key).toUpperCase(),
                                            values: Object.assign(
                                                {},
                                                json[i].values,
                                                { INSTRUMENT_TYPE: 'CRYPTO' }
                                            ),
                                        };
                                    }
                                }

                                return null;
                            }
                        );
                    }
                    return null;
                },
            },
            { type: CRYPTOCURRENCY_FETCH.FAILURE },
        ],
    },
});



/** WEBPACK FOOTER **
 ** /src/shared/actions/ticker.js
 **/